module.exports = __webpack_public_path__ + "static/media/galerija_2022_0057.48550cf4.jpg";